<div class="baseline-card">
	<div class="zk-flex zk-justify-between">
		<div class="zk-flex zk-gap-1">
			<span class="baseline__title">{{ 'CONTACT.BASELINE' | translate }}</span>
			<div freud-tooltip [tooltipLabel]="tooltipLabel">
				<span class="freud-icon freud-icon-info-circle"></span>
			</div>
		</div>
		<span></span>
	</div>
	<div class="zk-flex zk-my-3">
		<div
			[ngClass]="'baseline__level baseline__level-' + level"
			*ngFor="let level of [1, 2, 3, 4, 5, 6, 7]"
		>
			<div class="baseline__tick" *ngIf="baseline?.level === level"></div>
		</div>
	</div>
	<div class="zk-flex zk-items-center zk-gap-3 zk-pt-2">
		<span class="baseline__description">{{
			baseline && baseline?.level !== 0
				? ('CONTACT.BASELINE_FIRST_AVALIATION_AS' | translate)
				: ('CONTACT.BASELINE_NOT_REGISTERED' | translate)
		}}</span>
		<div class="baseline__tag" [ngClass]="'baseline__tag-' + baseline?.level">
			{{ baseline?.levelDescription }}
		</div>
	</div>
</div>
